<template>
    <basketPage/>
</template>

<script>
import basketPage from "./components/basketPage";
export default {
  name: 'App',
  components: {
      basketPage
  }
}
</script>

